import { View } from "binder"
import { BenefitSalesViewModel } from "./benefitSales-viewModel"

export class BenefitSalesView extends View<BenefitSalesViewModel>{
    GetViewUniqueId(): string {
        return "V-E52752A4-AD86-45D1-A14F-1DD3E90B12AE"
    }
    loadHtml(): string {
        let element = require('./benefitSales.html').default;
        let style = require('./benefitSales.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    download(){
        this.dataContext.download();
    }
    
}
